import $ from 'jquery';
import config from '../../../config';
import {showError} from '../../layouts/actions';
import {getErrorMessage} from '../../utils';
import {
  STATUS_DASHBOARD_INGESTS_LOADING,
  STATUS_DASHBOARD_INGESTS_SUCCESS,
  STATUS_DASHBOARD_INGESTS_ERROR,
  STATUS_DASHBOARD_TRANSFERS_LOADING,
  STATUS_DASHBOARD_TRANSFERS_SUCCESS,
  STATUS_DASHBOARD_TRANSFERS_ERROR,
  STATUS_DASHBOARD_PROXIES_LOADING,
  STATUS_DASHBOARD_PROXIES_SUCCESS,
  STATUS_DASHBOARD_PROXIES_ERROR,
  STATUS_DASHBOARD_FAILED_ACTIONS_LOADING,
  STATUS_DASHBOARD_FAILED_ACTIONS_SUCCESS,
  STATUS_DASHBOARD_FAILED_ACTIONS_ERROR,
  STATUS_DASHBOARD_CS_PENDING_LOADING,
  STATUS_DASHBOARD_CS_PENDING_SUCCESS,
  STATUS_DASHBOARD_CS_PENDING_ERROR,
  STATUS_DASHBOARD_WORK_ORDERS_LOADING,
  STATUS_DASHBOARD_WORK_ORDERS_SUCCESS,
  STATUS_DASHBOARD_WORK_ORDERS_ERROR
} from './constants';

const buildParams = (hours) => {
  const params = {};
  if (hours) {
    params.hours = hours;
  }
  return params;
};

export const getIngests = (hours) => dispatch => {
  dispatch({type: STATUS_DASHBOARD_INGESTS_LOADING});

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/status_dashboard/ingests`,
    data: buildParams(hours)
  })
  .done(res => {
    dispatch({type: STATUS_DASHBOARD_INGESTS_SUCCESS, data: res || []});
  })
  .fail(error => {
    dispatch({type: STATUS_DASHBOARD_INGESTS_ERROR, error: getErrorMessage(error)});
    dispatch(showError(`Could not get ingests. ${getErrorMessage(error)}`));
  });
};

export const getTransfers = (hours) => dispatch => {
  dispatch({type: STATUS_DASHBOARD_TRANSFERS_LOADING});

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/status_dashboard/transfers`,
    data: buildParams(hours)
  })
  .done(res => {
    dispatch({type: STATUS_DASHBOARD_TRANSFERS_SUCCESS, data: res || []});
  })
  .fail(error => {
    dispatch({type: STATUS_DASHBOARD_TRANSFERS_ERROR, error: getErrorMessage(error)});
    dispatch(showError(`Could not get transfers. ${getErrorMessage(error)}`));
  });
};

export const getProxies = (hours) => dispatch => {
  dispatch({type: STATUS_DASHBOARD_PROXIES_LOADING});

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/status_dashboard/proxies`,
    data: buildParams(hours)
  })
  .done(res => {
    dispatch({type: STATUS_DASHBOARD_PROXIES_SUCCESS, data: res || []});
  })
  .fail(error => {
    dispatch({type: STATUS_DASHBOARD_PROXIES_ERROR, error: getErrorMessage(error)});
    dispatch(showError(`Could not get proxies. ${getErrorMessage(error)}`));
  });
};

export const getFailedActions = (hours) => dispatch => {
  dispatch({type: STATUS_DASHBOARD_FAILED_ACTIONS_LOADING});

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/status_dashboard/failed_actions`,
    data: buildParams(hours)
  })
  .done(res => {
    dispatch({type: STATUS_DASHBOARD_FAILED_ACTIONS_SUCCESS, data: res || []});
  })
  .fail(error => {
    dispatch({type: STATUS_DASHBOARD_FAILED_ACTIONS_ERROR, error: getErrorMessage(error)});
    dispatch(showError(`Could not get failed actions. ${getErrorMessage(error)}`));
  });
};

export const getCsPending = () => dispatch => {
  dispatch({type: STATUS_DASHBOARD_CS_PENDING_LOADING});

  return $.ajax({
    method: 'GET',
    url: `${config.apiUrl}/v1/status_dashboard/cs_pending`
  })
  .done(res => {
    dispatch({type: STATUS_DASHBOARD_CS_PENDING_SUCCESS, data: res || []});
  })
  .fail(error => {
    dispatch({type: STATUS_DASHBOARD_CS_PENDING_ERROR, error: getErrorMessage(error)});
    dispatch(showError(`Could not get CS pending items. ${getErrorMessage(error)}`));
  });
};

export const getWorkOrders = (woMemfisList, hours) => dispatch => {
  dispatch({type: STATUS_DASHBOARD_WORK_ORDERS_LOADING});

  const params = buildParams(hours);
  const queryString = $.param(params);
  const url = `${config.apiUrl}/v1/status_dashboard/work_orders${queryString ? '?' + queryString : ''}`;

  return $.ajax({
    method: 'POST',
    url: url,
    contentType: 'application/json',
    data: JSON.stringify(woMemfisList || [])
  })
  .done(res => {
    dispatch({
      type: STATUS_DASHBOARD_WORK_ORDERS_SUCCESS,
      data: (res && res.data) || [],
      fileMakerURL: res && res.fileMakerURL,
      qcOnDemandBaseUrl: res && res.qcOnDemandBaseUrl
    });
  })
  .fail(error => {
    dispatch({type: STATUS_DASHBOARD_WORK_ORDERS_ERROR, error: getErrorMessage(error)});
    dispatch(showError(`Could not get work orders. ${getErrorMessage(error)}`));
  });
};
